var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#de2600",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.972 27.931c-.5 0-.917-.208-1.23-.52l-5.752-5.754-5.753 5.753c-.313.334-.75.521-1.23.521a1.76 1.76 0 0 1-1.751-1.75c0-.48.208-.897.521-1.21l5.774-5.774-5.774-5.773a1.654 1.654 0 0 1-.521-1.188c0-.98.792-1.73 1.75-1.73.48 0 .876.187 1.189.52l5.795 5.754 5.815-5.774c.354-.375.73-.521 1.188-.521.98 0 1.751.77 1.751 1.73 0 .458-.167.854-.521 1.188l-5.774 5.794 5.753 5.753a1.7 1.7 0 0 1 .521 1.23c0 .96-.77 1.751-1.75 1.751z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationError);
export default __webpack_public_path__ + "static/media/notification-error.5f2d87877e61ba63528da5ecdac2ef46.svg";
export { ForwardRef as ReactComponent };